import {getSubdomainFromUrl} from "@/lib/helper/urlSubdomain";

export function GetApiUrl() {
    return process.env.REACT_APP_API_URL
}

export function LeafletMapTileUrl() {
    return process.env.REACT_APP_MAP_TILE_URL
}

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const DISABLE_STUDENT_MAP = process.env.REACT_APP_DISABLE_STUDENT_MAP;
export const APP_CLIENT = process.env.REACT_APP_CLIENT;

export const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_ID;


export const OLD_DOMAIN = process.env.REACT_APP_OLD_DOMAIN;


// export function oldDomain(path) {
//     return OLD_DOMAIN + '/' + path;
// }

export function oldDomain(path) {

    const mySubdomain = getSubdomainFromUrl();

    let resolvedDomain = (OLD_DOMAIN && OLD_DOMAIN.includes('*'))
        ? OLD_DOMAIN.replace('*', mySubdomain || '')
        : OLD_DOMAIN;

    const cleanPath = path.replace(/^\/+/, '');

    return `${resolvedDomain}/${cleanPath}`;
}